import { AuthContext, FireactContext, SetPageTitle } from "../lib/core";
import { Box, Button, Card, CardContent, Container, Grid, Typography, Divider } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../template/Footer";
import OpacityIcon from '@mui/icons-material/Opacity';
import ScheduleIcon from '@mui/icons-material/Schedule';
import VerifiedIcon from '@mui/icons-material/VerifiedUser';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import "./About.css";

const About = ({loader}) => {

    const { authInstance, authUser } = useContext(AuthContext);
    const { config } = useContext(FireactContext);
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        setLoaded(false);
        setError(null);
        setLoaded(true);
    },[authInstance, config.saas.permissions]);

    return (
        <>
            {loaded ? (
                <Container maxWidth={false} disableGutters>
                    <SetPageTitle title="About" />

                    <Box className="about-hero">
                        <Container>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={7}>
                                    <Typography variant="h2" className="hero-title">Living Waters</Typography>
                                    <Typography variant="h6" color="text.secondary" className="hero-sub">
                                        A modern, trusted platform connecting licensed nurses with
                                        customers seeking safe, convenient IV therapy—anytime, anywhere.
                                    </Typography>
                                    <Box sx={{ mt: 3 }}>
                                        { (authUser?.user === null) && (
                                            <Button variant="contained" color="primary" sx={{ mr: 2 }} onClick={() => navigate('/sign-in')}>Get Started</Button>
                                        ) }
                                        <Button variant="outlined" color="secondary" onClick={() => navigate('/contact')}>Contact Us</Button>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <Box className="hero-art">
                                        <OpacityIcon sx={{ fontSize: 120, color: 'primary.main' }} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Container>
                    </Box>

                    <Container sx={{ py: 6 }}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <SupportAgentIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>For Nurses</Typography>
                                        <Typography color="text.secondary">Tools for flexible scheduling, license verification, and earnings management.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <VerifiedIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Verified & Secure</Typography>
                                        <Typography color="text.secondary">Verified nurses, secure Stripe payments, and clear communication.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card className="feature-card">
                                    <CardContent>
                                        <ScheduleIcon className="feature-icon" />
                                        <Typography variant="h6" gutterBottom>Easy Booking</Typography>
                                        <Typography color="text.secondary">Book in-home IV therapy via web or iOS with real-time updates.</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>

                        <Divider sx={{ my: 6 }} />

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" gutterBottom>Our Mission</Typography>
                                <Typography color="text.secondary">We make high-quality IV therapy accessible and simple to provide — prioritizing safety, transparency, and convenience.</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" gutterBottom>Why Living Waters</Typography>
                                <ul className="why-list">
                                    <li>A trusted, compliant platform for nurses and customers.</li>
                                    <li>Seamless scheduling and payments.</li>
                                    <li>Real-time notifications and clear communication.</li>
                                </ul>
                            </Grid>
                        </Grid>
                    </Container>

                    <Footer />
                </Container>
            ) : (
                <>{loader}</>
            )}
        </>
    )
}

export default About;
